import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
import styled from "styled-components";

export default function Iconify({
    icon = "mdi:account",
    size = "60px",
    mobileSize = "30px",
    onClick = null,
    cursor = "default",
    Color = "white",
    iconMargin = "",
    style = { marginLeft: "10px" },
}) {
    const isImage =
        (typeof icon === "string" &&
            (icon.endsWith(".png") ||
                icon.endsWith(".jpg") ||
                icon.endsWith(".jpeg") ||
                icon.endsWith(".svg") ||
                icon.startsWith("data:image/"))) ||
        (typeof icon === "object" && icon && (icon.default || icon.src));

    return isImage ? (
        <ResponsiveImage
            src={icon}
            onClick={onClick}
            size={size}
            mobileSize={mobileSize}
            style={style}
            cursor={cursor}
            alt="icon"
        />
    ) : (
        <ResponsiveIcon
            iconMargin={iconMargin}
            Color={Color}
            icon={icon}
            onClick={onClick}
            size={size}
            mobileSize={mobileSize}
            style={style}
            cursor={cursor}
        />
    );
}

Iconify.propTypes = {
    icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    size: PropTypes.string,
    mobileSize: PropTypes.string,
    onClick: PropTypes.func,
    Color: PropTypes.any,
    iconMargin: PropTypes.string,
    style: PropTypes.object,
    cursor: PropTypes.string,
};

const ResponsiveIcon = styled(Icon)`
    font-size: ${(props) => props.size};
    color: ${(props) => props.Color};
    margin: ${(props) => (props.iconMargin ? props.iconMargin : "0 auto")};
    vertical-align: text-bottom;
    cursor: ${(props) => (props.cursor ? props.cursor : "default")};

    @media (max-width: 960px) {
        font-size: ${(props) => (props.mobileSize ? props.mobileSize : props.size)};
    }
`;

const ResponsiveImage = styled.img`
    width: ${(props) => props.size};
    height: ${(props) => props.size};
    cursor: ${(props) => (props.cursor ? props.cursor : "default")};
    object-fit: contain;

    @media (max-width: 768px) {
        width: ${(props) => (props.mobileSize ? props.mobileSize : props.size)};
        height: ${(props) => (props.mobileSize ? props.mobileSize : props.size)};
    }
`;
